import PropTypes from "prop-types"
import { useEffect, useState } from "react"
import { noop, size } from "lodash"
import Modal from "@mui/material/Modal"
import { ROLE } from "helpers/shapes"
import Login from "modules/login"
import { Outlet, useMatches, useNavigate } from "react-router-dom"
import "./style.scss"

function getTitle(accountName) {
  if (accountName) {
    return `${accountName} - Portfolio Intelligence`
  }

  return "Portfolio Intelligence"
}
export default function AccountRoot({ loadAccount, accountAlias, accountName, selectPortfolio, sessionExpired, needSignTerms, isSuperuser, role, account, models, datasetEntitlementsEnabled }) {
  const [isLoaded, setIsLoaded] = useState(false)
  const navigate = useNavigate()
  const matches = useMatches()
  const atRootMatch = matches.length === 1

  useEffect(() => {
    if (accountAlias) {
      loadAccount(accountAlias)
    }
  }, [accountAlias, loadAccount])

  useEffect(() => {
    if (accountName) {
      document.title = getTitle(accountName)
    }
  }, [accountName])

  useEffect(() => {
    if (!account) {
      return
    }
    if (needSignTerms && !isSuperuser) {
      let url = `/${accountAlias}/account-not-activated`
      if (role === "admin") {
        url = `/${accountAlias}/terms-and-conditions`
      }
      navigate(url, { replace: true })
    } else if (atRootMatch) { // we're at the root match
      // If you arrive at the root, redirects you to the latest portfolio seen, or to home if your first visit
      const lastPortfolios = JSON.parse(window.localStorage.getItem(`OP_${accountAlias}_LastPortfolios`))

      let url = `/${accountAlias}/home`
      if (lastPortfolios && lastPortfolios.length) {
        const id = lastPortfolios[0].shortId || lastPortfolios[0].id
        url = `/${accountAlias}/p/${id}`
        selectPortfolio(id)
      }

      navigate(url, { replace: true })
    }

    setIsLoaded(true)
  }, [account, needSignTerms, isSuperuser, atRootMatch, role, accountAlias, selectPortfolio, navigate])

  // Member with no datasets check
  useEffect(() => {
    if (isSuperuser || needSignTerms || !account) {
      return
    }
    if (datasetEntitlementsEnabled && !size(models) && role !== "admin") {
      navigate("/contact-admin?risk-model", { replace: true })
    }
  }, [accountAlias, models, role, navigate, account, needSignTerms, isSuperuser, datasetEntitlementsEnabled])

  // This is to prevent `children` from being rendered (and queries fired) before knowing if we need to redirect or not
  if (!isLoaded) {
    return null
  }

  return (<>
    <div className="modules_account-root">
      <Outlet />
    </div>
    {sessionExpired && <Modal onClose={() => noop()} className="modules_account-root-sign-in" open>
      <div className="login-popup-container">
        <Login isRefreshMode />
      </div>
    </Modal>}
  </>
  )
}

AccountRoot.propTypes = {
  children: PropTypes.object,
  loadAccount: PropTypes.func.isRequired,
  selectPortfolio: PropTypes.func.isRequired,
  accountAlias: PropTypes.string.isRequired,
  portfolios: PropTypes.array,
  accountName: PropTypes.string,
  sessionExpired: PropTypes.bool.isRequired,
  needSignTerms: PropTypes.bool.isRequired,
  isSuperuser: PropTypes.bool.isRequired,
  role: ROLE,
  account: PropTypes.string,
  models: PropTypes.array,
  datasetEntitlementsEnabled: PropTypes.bool.isRequired,
}
